var exports = {
  "zr": "TaskMentionsActivity.module__root___Q3RkYT",
  "R_": "TaskMentionsActivity.module__heading___Q3RkYT",
  "p_": "TaskMentionsActivity.module__list___Q3RkYT",
  "AS": "TaskMentionsActivity.module__item___Q3RkYT",
  "oS": "TaskMentionsActivity.module__avatarBlank___Q3RkYT",
  "rf": "TaskMentionsActivity.module__body___Q3RkYT",
  "n8": "TaskMentionsActivity.module__line___Q3RkYT",
  "Qq": "TaskMentionsActivity.module__text___Q3RkYT",
  "kB": "TaskMentionsActivity.module__time___Q3RkYT",
  "Om": "TaskMentionsActivity.module__dot___Q3RkYT",
};

module.exports = exports;
